import { render, staticRenderFns } from "./AssignmentTableItemForm.vue?vue&type=template&id=60d5e7bc&"
import script from "./AssignmentTableItemForm.vue?vue&type=script&lang=js&"
export * from "./AssignmentTableItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports